export default {
  name: 'LinkIcon',
  props: {
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 10
    },
    color: {
      type: String,
      default: '#71777F'
    }
  }
};